import React from 'react';
import { css } from 'aphrodite';
import styles from './header-styles';
import SiteSearch from './site-search';

const HeaderView = (props) => (
  <div className={css(styles.root, props.layout.sidebarCollapsed && styles.rootSidebarCollapsed)}>
    <div className={css(styles.content)}>
      <SiteSearch title={props.headerTitle} />
    </div>
  </div>
);

export default HeaderView;



// WEBPACK FOOTER //
// ./src/components/layout/header-view.js